/* eslint-disable max-len */
import React, { useMemo, useEffect, useState, useRef, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { useLocation, useNavigate } from "react-router-dom";
import styled, { CSSProperties } from "styled-components";
import Button from "../../components/Button";
import CustomRoadmap from "../../components/CustomRoadmap";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Icon from "../../components/Icon";
import { Col, Row } from "../../components/StyledGridSystem";
import { StyledText } from "../../components/Text";
import ViewSelect from "../../components/ViewSelect";
import { UserContext } from "../../context/UserContext";
import theme from "../../styles/theme";
import { CustomFlex } from "./RoadMapTimeline";
import axios from "axios";
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 76px);
  height: -moz-calc(100vh - 76px);
  height: -o-calc(100vh - 76px);
  height: -webkit-calc(100vh - 76px);
  overflow-y: hidden;
  overflow-x: overlay;
`;
const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.33);
  padding: 7px 12px;
  height: 36px;
  border: 1px solid #e7ebee;
  box-sizing: border-box;
  backdrop-filter: blur(33px);
  border-radius: 6px;
  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.33);
  }
`;
export const StyledAddButton = styled(Button)`
  margin-right: 24px;
  background: linear-gradient(270deg, #3a84ee 0%, #1a5edf 100%);
  backdrop-filter: blur(44px);
  padding: 6px 12px;
  border-radius: 6px;
  &:hover:not(:disabled) {
    background: linear-gradient(270deg,rgb(58, 132, 238),rgb(58, 132, 238));
  }
`;
const ActiveButton: CSSProperties | undefined = {
  background: "rgb(167 54 56)",
  border: "1px solid #808080",
  padding: "7px 10px",
  height: "36px",
  boxSizing: "border-box",
  backdropFilter: "blur(33px)",
  borderRadius: "6px",
};
const NormalButton: CSSProperties | undefined = {
  background: "rgb(57 72 96)",
  border: "1px solid #808080",
  padding: "7px 10px",
  height: "36px",
  boxSizing: "border-box",
  backdropFilter: "blur(33px)",
  borderRadius: "6px",
};
function RoadMapPage() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const [credits, setCredits] = useState("");
  const redirectTimeline = () => {
    userContext.setCurrentRoadmapView({
      name: "timeline",
      url: "/roadmap/timeline",
    });
    navigate("/roadmap/timeline");
  };
  const redirectExplore = () => {
    navigate("/explore");
  };
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  const [currentView, setCurrentView] = useState<"week" | "month">("month");

  const fetchAnouncement = async () => {};

  return (
    <>
      <CustomFlex
        $sidebarOpen={userContext.roadmapView.sidebar}
        $isMobile={isMobile}
      >
        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <>
            <ViewSelect />
          </>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          <StyledButton
            onClick={() => {
              redirectTimeline();
            }}
            style={{ whiteSpace: "nowrap" }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="chart-bar"
                />
                Timeline
              </>
            ) : (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="chart-bar"
                />
              </>
            )}
          </StyledButton>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          <StyledAddButton
            style={{ margin: 0, whiteSpace: "nowrap" }}
            onClick={() => {
              redirectExplore();
            }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="plus-circle"
                />
                Add Milestone
              </>
            ) : (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="plus-circle"
                />
              </>
            )}
          </StyledAddButton>
        </FlexGrow>

        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <StyledText>Credits: {credits}</StyledText>
        </FlexGrow>
      </CustomFlex>
      <CustomRow wrap="nowrap" className="visible-scrollbar">
        <Col style={{ padding: 0 }}>
          <CustomRoadmap
            view={userContext.timeView.value}
            setCredits={setCredits}
          />
        </Col>
      </CustomRow>
    </>
  );
}
export default RoadMapPage;
